(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["egodeath-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var creditGroups = [
    {
      label: "Creators & Team",
      tag: "TEAM",
      names: [
        "GOD","C.Y. LEE.","DOLBY ATMOS","ELYSE THOMS","BRENDAN BOYLE","SHIV",
        "ISAIAH RAY PEARCE","SAMANTHA","ROANN MESINA","TYIE RIED","KYLA EVEILLARD",
        "GENESIS JACKSON","AMANI ELLIS","DARRYL KEITH","MYSHIA CHEATHAM","AFI EL",
        "GOOD JOON","JA\u2019MAAL HASSAN","MISTRESS OF RAP","TAHMIQUE CAMERON",
        "ABDOU","LALA","KAELIN ELLIS","SAM GIRARDOT","TAYLOR ALFORD"
      ]
    },
    {
      label: "Tier 1 \u2014 Supporters",
      tag: "SUPPORTER",
      names: [
        "SHANE FULLER","IAN MIACHAEL","MERRILL M GARBUS","DOMINIQUE ALEXANDRA",
        "ADRIENNE KENNEDY","KAREN BAKER","KAYA JAMES","AGYEI MCARTHUR",
        "CHRISTOPHER JETER","ERIN POWELL","NIKKI DELTS","SAMANTHA BUNTING",
        "ANTHONY LABELLARTE","JOHNIE C JENKINS JR","JULIE ADAMS","CYDNEY IRBY",
        "JOHNIE C JENKINS JR","SONYA FOX","LA\u2019KI COLLINS","BEE JONES", "URSULA CAMPBELL", "JENNIFER SCOTT", "KAYLYN WRIGHT", "EMMANUEL RICKETTS", "RUTH JEREMIAH", "NICOLE HARBIN",
      ]
    },
    {
      label: "Tier 2 \u2014 Collaborators",
      tag: "COLLABORATOR",
      names: [
        "IMAN EUROPE","ESTHER RATTIGAN","YUSEF HARRIS","DAVID SMART",
        "ALEXIS WILSON","KIMANI GLASS","ARI HERSTAND","LARON WALKER", "DEREK G. TAYLOR"
      ]
    },
    {
      label: "Tier 3 \u2014 Architect",
      tag: "ARCHITECT",
      names: [
        "DAVID CHAVARRIA","LESLEE HUDSON","NICHOLAS FULCHER","ALAN LILI", "DAVID TYSON"
      ]
    },
    {
      label: "Tier 4 \u2014 The Visionary",
      tag: "VISIONARY",
      names: [
        "DILAN KENNEDY"
      ]
    }
  ];

  function buildRowsHTML(){
    var html = "";
    creditGroups.forEach(function(group){
      html += '<div class="ed-group-header">' + group.label + '</div>';
      group.names.forEach(function(name){
        html += '<div class="ed-credit-row"><span class="ed-name">' + name +
                '</span><span class="ed-tier-tag">' + group.tag + '</span></div>';
      });
    });
    return html;
  }

  function totalCount(){
    return creditGroups.reduce(function(sum, g){ return sum + g.names.length; }, 0);
  }

  document.addEventListener('DOMContentLoaded', function(){
    var track = document.getElementById('edCreditsTrack');
    var countEl = document.getElementById('edWallCount');
    if(!track) return;
    var rows = buildRowsHTML();
    track.innerHTML = rows + rows;
    if(countEl){
      countEl.innerHTML = 'CO-CREATORS TO DATE \u2014 <b>' + totalCount() + '</b>';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
